package fr.frux.feature.treedetail.site

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.Forest
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.semantics.Role
import androidx.compose.ui.unit.dp
import fr.frux.core.designsystem.components.FruxButton
import fr.frux.core.designsystem.components.FruxButtonStyle
import fr.frux.feature.treedetail.resources.Res
import fr.frux.feature.treedetail.resources.treedetail_site_detach
import fr.frux.feature.treedetail.resources.treedetail_site_invite_only
import fr.frux.feature.treedetail.resources.treedetail_site_label
import fr.frux.feature.treedetail.resources.treedetail_site_none
import org.jetbrains.compose.resources.stringResource

/**
 * Ligne « Lieu » du bloc Identité : le lieu de l'arbre (touche, ouvre sa fiche) ou « Aucun, arbre
 * isolé ». « Détacher » n'apparaît que pour un compte qui peut écrire sur ce lieu. Mêmes mesures
 * que les autres lignes du bloc (72 dp, disque de 40 dp).
 */
@Composable
internal fun SiteIdentityRow(
    ui: TreeSiteUi,
    onOpenSite: (Long) -> Unit,
    onDetach: () -> Unit,
) {
    val scheme = MaterialTheme.colorScheme
    val linked = ui.linked
    Row(
        modifier =
            Modifier
                .fillMaxWidth()
                .then(
                    if (linked != null) {
                        Modifier.clickable(role = Role.Button) { onOpenSite(linked.id) }
                    } else {
                        Modifier
                    },
                ).heightIn(min = 72.dp)
                .padding(start = 16.dp, top = 12.dp, end = 6.dp, bottom = 12.dp),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.spacedBy(12.dp),
    ) {
        Box(
            modifier = Modifier.size(40.dp).background(scheme.surfaceVariant, CircleShape),
            contentAlignment = Alignment.Center,
        ) {
            Icon(
                imageVector = Icons.Outlined.Forest,
                contentDescription = null,
                tint = scheme.primary,
                modifier = Modifier.size(20.dp),
            )
        }
        Column(modifier = Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(1.dp)) {
            Text(
                text = stringResource(Res.string.treedetail_site_label),
                style = MaterialTheme.typography.bodyMedium,
                color = scheme.onSurfaceVariant,
            )
            Text(
                text = linked?.name ?: stringResource(Res.string.treedetail_site_none),
                style = MaterialTheme.typography.titleMedium,
                color = if (linked != null) scheme.primary else scheme.onSurfaceVariant,
            )
            if (ui.harvestLocked) {
                Text(
                    text = stringResource(Res.string.treedetail_site_invite_only),
                    style = MaterialTheme.typography.bodyMedium,
                    color = scheme.onSurfaceVariant,
                )
            }
        }
        if (linked != null && ui.canDetach) {
            FruxButton(
                text = stringResource(Res.string.treedetail_site_detach),
                onClick = onDetach,
                loading = ui.busy,
                style = FruxButtonStyle.Text,
            )
        }
    }
}
